module.exports = __webpack_public_path__ + "static/media/wedding.b39d57b3.webp";